export default __webpack_public_path__ + "static/media/unpublish.874a3813.svg";